import {
  GetSelfAssessmentById,
  GetSelfAssessmentByIdVariables,
} from "__generated__/types";
import { Button } from "common/buttons";
import { Box } from "common/components/Box";
import { LoadingLayout } from "common/components/layouts/LoadingLayout";
import { NormalContentLayout } from "common/components/layouts/NormalContentLayout";
import { NoDataError } from "common/components/NoDataError";
import { useSimpleQuery } from "common/graphql/useSimpleQuery";
import { urls } from "common/urls";
import gql from "graphql-tag";
import React from "react";
import { useNavigate, useParams } from "react-router";

const DATA_QUERY = gql`
  query GetSelfAssessmentById($id: ID!) {
    selfAssessmentById(id: $id) {
      id
      title
      originFolderId
      originFolderParentId
      status
      delivery {
        deliveredAt
        score {
          factorPercent
        }
      }
    }
  }
`;

type RouteProps = {
  selfAssessmentInstanceId: string;
};

export const SelfAssessmentPage: React.FC = () => {
  const { selfAssessmentInstanceId } = useParams<RouteProps>();
  const navigate = useNavigate();
  const { data, loadingOrError } = useSimpleQuery<
    GetSelfAssessmentById,
    GetSelfAssessmentByIdVariables
  >(DATA_QUERY, {
    variables: {
      id: selfAssessmentInstanceId as string,
    },
  });

  if (loadingOrError) {
    return <LoadingLayout>{loadingOrError}</LoadingLayout>;
  }

  if (!data || !data.selfAssessmentById) {
    return (
      <LoadingLayout>
        <NoDataError />
      </LoadingLayout>
    );
  }

  const { originFolderParentId, title, delivery } = data.selfAssessmentById;

  const score = delivery?.score.factorPercent;

  const handleRedirectToFolderWithSelfAssessments = () => {
    if (originFolderParentId) {
      navigate(urls.folder(originFolderParentId));
    }
  };

  return (
    <NormalContentLayout title={title} isAdmin={false}>
      <Box>
        {score !== undefined ? (
          <>Du fikk {score * 100}% riktig!</>
        ) : (
          "Whops, noe gikk galt! Vi kunne ikke hente scoren din. "
        )}
        <Button onClick={handleRedirectToFolderWithSelfAssessments}>
          Tilbake til selvtester
        </Button>
      </Box>
    </NormalContentLayout>
  );
};
